// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
import {COMMENT_DRAWER_MODES} from '../../common/comment'
const initialState = {
  updateClientePending: false,
  updateClienteError: null,
  retryOfferDMSPending: false,
  retryOfferDMSError: null,
  retryOfferDMSSuccess: false,
  cliente: null,
  documents: {
    dni_titular: {
      hasPhysicalDocuments: false
    },
    dni_cotitular: {
      hasPhysicalDocuments: false
    },
    dni_conyuge: {
      hasPhysicalDocuments: false
    },
    servicio: {
      hasPhysicalDocuments: false
    },
    poder: {
      hasPhysicalDocuments: false
    },
    otros: {
      hasPhysicalDocuments: false
    }
  },
  getClientePending: false,
  getClienteError: null,
  getPresupuestoPending: false,
  getPresupuestoError: null,
  getAutoPending: false,
  getAutoError: null,
  geSalePending: false,
  getSaleError: null,
  getCotizacionPending: false,
  getCotizacionError: null,
  getPeritajePending: false,
  getPeritajeError: null,
  patenteError: null,
  peritaciones: {},
  sale: null,
  initialBonAdicional: 0,
  initialBonEspecial: 0,
  isModified: false,
  bonificacionConcesionaria: 0,
  precioSubTotal: 0,
  precioTotal: 0,
  bonAdicionalError: null,
  bonEspecialUsadoError: null,
  bonEspecialError: null,
  billsPending: false,
  billsError: null,
  reportSalesPending: false,
  reportSalesError: null,
  updateTakingCarsPending: false,
  getLineasFinancierasError: null,
  savedSale: false,
  isAdditionalBonEditable: false,
  isSpecialBonEditable: false,
  isExtraBonEditable: false,
  maximoDescuento: {
    monto: 0,
    porcentaje: 0,
    remainder: 0
  },
  commentDrawerOpen: true,
  commentDrawerMode: COMMENT_DRAWER_MODES.CREATE,
  commentDrawerText: '',
  urlAddPayment: false,
  saveButtonDisabled: true,

  changeState:""
}

export default initialState
